/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as React from 'react';
import { SVGProps } from 'react';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const defaultScreenIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect
      x={5}
      y={7}
      width={14}
      height={10}
      rx={1.5}
      fill="none"
      strokeWidth={1.6}
    />
  </svg>
);
export default defaultScreenIcon;
